/**
 * Product-card interactions are registered once at the document level so cards
 * rendered by collection filters, search, or AJAX fragments work without
 * embedding a script in every card instance.
 */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('.fallback-atc');

  if (!button || button.disabled || button.classList.contains('loading')) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.setAttribute('disabled', 'disabled');
  button.classList.add('loading');
  button.querySelector('.loading-overlay')?.classList.remove('hidden');

  try {
    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!response.ok) throw new Error('Unable to add product to cart');

    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

    if (window.Woolman?.ModalsAndDrawers?.showModalOrDrawer) {
      window.Woolman.ModalsAndDrawers.showModalOrDrawer('drawer-cart');
    } else {
      window.location.href = window.routes?.cart_url || '/cart';
    }
  } catch (error) {
    console.error('Fallback add to cart failed:', error);
  } finally {
    button.classList.remove('loading');
    button.querySelector('.loading-overlay')?.classList.add('hidden');
    button.removeAttribute('disabled');
  }
});
